import { STROLLER_NO_RESULTS } from 'mk/autogenerated/translations/WishList.60d2eb12269a5795417a7a7a02d91f2a'
import { StrollersList } from 'mk2/apps/strollers/components/StrollersList';
import { Props } from 'mk2/apps/strollers/containers/WishList/WishListPage';
import { LoadingState } from 'mk2/reducers/loadingState';
import React from 'react';
import styles from './WishList.mscss';

export default class WishList extends React.Component<Props> {

    public componentDidMount() {
        this.props.onWishlistLoad();
    }

    public render() {
        const { hasMore, items, loadingState, onWishlistToggle, wishlist } = this.props;

        return (
            <div className={styles.WishList}>
                <StrollersList
                    onWishlistToggle={onWishlistToggle}
                    loadingState={loadingState}
                    items={items}
                    hasMore={hasMore}
                    noResultMessage={STROLLER_NO_RESULTS}
                    wishlist={wishlist}
                    loadNext={this.loadNext}
                    load={this.load}
                />
            </div>
        );
    }

    private load = () => {
        if (typeof window === 'undefined') {
            // do not load anything on server, we don't know wishlist cookie yet
            return;
        }
        this.props.onLoad();
    };

    private loadNext = () => {
        // Do not trigger next load
        if (this.props.loadingState === LoadingState.LOADING) {
            return;
        }

        const { items, onLoad } = this.props;

        let after = null;
        if (items.length) {
            after = items[items.length - 1].slug;
        }
        onLoad(after);

        // Debounce loadMoreRows
        return new Promise((resolve) => {
            setTimeout(resolve, 500);
        });
    };
}
